// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderConfirmationBillingInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationBillingInformation";
import { orderInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationOrderInformation";
import { GridItemProps } from "@insite/mobius/GridItem";
import {
    addressBlockStyle,
    orderInfoStyle,
} from "@rugby/App/WidgetExtensions/MyAccountPagesSharedStyle/DetailsPage.style";
import { css } from "styled-components";

const infoStyle: { gridItem: GridItemProps } = {
    gridItem: {
        width: 12,
        css: css`
            display: flex;
            align-items: center;
            flex-direction: row;
        `,
    },
};

orderInformationStyles.orderNumberHeading = {
    variant: "h2",
    as: "h1",
    css: css`
        margin-bottom: 0;
        @media print {
            font-size: 36px;
        }
    `,
};

orderInformationStyles.OrderInformationGridContainer = {
    gap: 30,
};

orderInformationStyles.shippingInformationGridItem = {
    width: [12, 6, 6, 6, 6],
};

orderInformationStyles.billingInformationGridItem = {
    width: [12, 6, 6, 6, 6],
};

orderInformationStyles.notesGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

orderInformationStyles.orderConfirmationShippingInformation = {
    shippingInformationGridContainer: {
        gap: 0,
    },
    shippingOtherInformationGridContainer: {
        gap: 0,
    },
    shippingInformationTitleGridItem: {
        css: css`
            display: none;
        `,
    },
    shippingInformationAddressGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
            &&& {
                margin-top: 30px;
            }

            order: 3;
        `,
    },
    shippingOtherInformationGridItem: {
        width: 12,
        css: css`
            order: 2;
        `,
    },
    shippingAddressTitle: addressBlockStyle.titleText,

    shippingInformationCarrierGridItem: infoStyle.gridItem,
    shippingCarrierTitle: orderInfoStyle.orderLabel,
    shippingCarrierDescription: orderInfoStyle.orderValue,

    shippingInformationDateRequestedGridItem: infoStyle.gridItem,
    shippingDateRequestedTitle: orderInfoStyle.orderLabel,
    shippingDateRequestedText: orderInfoStyle.orderValue,

    shippingInformationServiceGridItem: infoStyle.gridItem,
    shippingServiceTitle: orderInfoStyle.orderLabel,
    shippingServiceDescription: orderInfoStyle.orderValue,

    shippingInformationPoNumberGridItem: infoStyle.gridItem,
    shippingPoNumberTitle: orderInfoStyle.orderLabel,
    shippingPoNumberText: orderInfoStyle.orderValue,
};

orderInformationStyles.orderConfirmationBillingInformation = {
    ...orderInformationStyles.orderConfirmationBillingInformation,
    ...orderConfirmationBillingInformationStyles,
    billingAddressTitle: { ...addressBlockStyle.titleText },
    billingCreditCardAddressTitle: addressBlockStyle.titleText,
    billingInformationTitleGridItem: {
        css: css`
            display: none;
        `,
    },
    billingInformationBillingAddressGridItem: {
        ...orderInformationStyles.orderConfirmationBillingInformation?.billingInformationBillingAddressGridItem,
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    billingInformationCreditCardAddressGridItem: {
        ...orderInformationStyles.orderConfirmationBillingInformation?.billingInformationCreditCardAddressGridItem,
        width: 12,
        css: css`
            flex-direction: column;

            &&& {
                margin-top: 30px;
            }
        `,
    },
};

orderInformationStyles.orderDetailsGridContainer = {
    css: css`
        padding-left: 5px;
        padding-bottom: 15px;
        @media print {
            margin-left: 20px;
        }
    `,
};
